import React, { useContext, useMemo } from 'react'

import LinkWidget, { LinkDetail } from '@/components/shared/link-widget'
import SubCategoryContext from '@/context/sub-category'

import { getFilteredOtherCategoryLinks } from './utils'

interface OtherCategoriesProps {
    title: string
    links: LinkDetail[]
}

const OtherCategories: React.FC<OtherCategoriesProps> = ({ title, links: allLinks }) => {
    const {
        selectors: {
            subCategoryParams: { webPath: subCategoryWebPath },
        },
    } = useContext(SubCategoryContext)

    const filteredOtherCategoryLinks: LinkDetail[] = useMemo(() => {
        return getFilteredOtherCategoryLinks({ allLinks, excludedUrl: subCategoryWebPath })
    }, [allLinks, subCategoryWebPath])

    return <LinkWidget title={title} links={filteredOtherCategoryLinks} />
}

export default OtherCategories
